<br />
<br />
<div class="row w-100 mt-3 mx-0 justify-content-center mt-5">
  <div class="col-12 col-md-7 col-lg-8 my-auto px-5 order-md-1 order-2">
    <div class="title">
      {{ "Genrate Cover Letter" | translate }}
    </div>
    <div class="description">
      {{
        "Generate your Cover Letter. Get Reach to right people, New opportunities."
          | translate
      }}
    </div>

    <button class="gradient-button">
      {{ "Build Your Cover Letter" | translate }}
    </button>
    <button class="border-button" routerLink="/soon">
      {{ "Scan your Cover Letter" | translate }}
    </button>
  </div>
  <img
    class="col-8 col-md-5 col-lg-4 text-center p-0 order-md-2 order-1"
    src="../../../assets/img/optimize-linkedIn.png"
  />
</div>
<div class="scan">{{ "Generate Cover Letter" | translate }}</div>
<div class="my-4">
  <p-steps [model]="steps" [(activeIndex)]="activeIndex" />
</div>

<div
  class="row w-100 m-0"
  *ngIf="activeIndex === 0"
  (dragover)="onDragOver($event)"
  (drop)="onLinkedinDrop($event)"
>
  <div class="w-100 col-lg-8 col-sm-7 col-12 p-0">
    <div class="upload-resume">
      <img width="15%" src="../../../assets/img/upload linkedin.png" />

      <h3>{{ "Upload your CV in PDF" | translate }}</h3>
      <p>{{ "Drag and drop your resume as PDF or word file" | translate }}</p>
      <p>{{ "Or" | translate }}</p>
      <input
        type="file"
        id="uploadLinkedin"
        (change)="onLinkedinSelected($event)"
        accept=".pdf,.doc,.docx"
        #uploadLLinked
        hidden
      />
      <button class="button" (click)="uploadLLinked.click()">
        {{ "Select of Browser" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="m-5">
  <div class="title">{{ "Resume optimization checklist" | translate }}</div>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-4">
      {{
        "We check for 16 crucial things across 5 different categories on your resume including content, file type, and keywords in the most important sections of your resume. Here’s a full list of the checks you’ll receive:"
          | translate
      }}
    </div>

    <app-card
      *ngFor="let item of services"
      [color]="item.color"
      [img]="item.img"
      [icon]="true"
      [title]="item.title"
      [description]="item.description"
    />
  </div>
</div>
